import React from "react";
import UsersPanel from "../components/usersPanel";

function UsersPage() {
  return <UsersPanel />;
}

UsersPage.propTypes = {};
UsersPage.defaultProps = {};

export default UsersPage;
